import { VerifilinkReport } from 'components/Report';
import { endpoints } from 'api';

function VerifilinkInProgressPage() {
    return (
        <VerifilinkReport APIEndpoint={endpoints.VL_GROUP_BY_IN_PROGRESS} ReportName='Verifilink In Progress' />
    );
}
export default VerifilinkInProgressPage;
